import React from 'react';

const BatteryLife = () => {
  return (
    <svg width='121' height='120' viewBox='0 0 121 120' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M33.593 29.09h27.814a5.8 5.8 0 0 1 5.8 5.8v61.114a5.8 5.8 0 0 1-5.8 5.8H33.593a5.8 5.8 0 0 1-5.8-5.8V34.89a5.8 5.8 0 0 1 5.8-5.8z'
        stroke='#000'
        strokeWidth='4.4'
      />
      <path d='M38 25a5 5 0 0 1 5-5h9a5 5 0 0 1 5 5H38z' fill='var(--theme-primary, #810ea9)' />
      <circle cx='76.045' cy='77.49' r='24.313' fill='#fff' stroke='#000' strokeWidth='4.4' strokeLinecap='round' strokeLinejoin='round' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M82.059 63.587a2.178 2.178 0 1 1 3.769 2.186l-8.582 14.794a2.178 2.178 0 0 1-3.769-2.186l8.582-14.794z'
        fill='var(--theme-primary, #810ea9)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M66.459 76.964a2.18 2.18 0 0 1 2.169-3.783l7.78 4.461a2.18 2.18 0 0 1-2.169 3.783l-7.78-4.461z'
        fill='var(--theme-primary, #810ea9)'
      />
    </svg>
  );
};

export default BatteryLife;
